import React, { useEffect, useMemo, type FC } from 'react'

import styled from '@emotion/styled'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  MODAL_SIZE_XL,
  Modal,
  ModalHead,
  TABBED_VARIANT_LIGHT,
  Tabbed,
  TooltipUtils,
} from 'mailup-web-components'

import TabEmptyField from 'Pages/RecipientsList/components/modals/bulkFindReplace/TabEmptyField'
import TabFindReplace from 'Pages/RecipientsList/components/modals/bulkFindReplace/TabFindReplace'

import { modalBulkFindReplaceCancelCallback } from 'Pages/RecipientsList/recoil/callbacks/modalBulkFindReplace'
import { modalBulkFindReplaceState } from 'Pages/RecipientsList/recoil/state/modalBulkFindReplace'

import useModalBulkFindReplacePreview from 'Pages/RecipientsList/hooks/useModalBulkFindReplacePreview'

const StyledModal = styled(Modal)`
  margin-top: 3vh;
`

const ModalBulkFindReplace: FC = () => {
  const intl = useIntl()

  useModalBulkFindReplacePreview()

  const { show } = useRecoilValue(modalBulkFindReplaceState)

  const handleCancel = useRecoilCallback(modalBulkFindReplaceCancelCallback, [])

  useEffect(() => {
    setTimeout(TooltipUtils.rebuild as () => void, 100)
  }, [show])

  const tabs = useMemo(
    () => [
      {
        label: intl.formatMessage({
          id: 'Load.RecipientsList.BulkActionFindReplace',
        }),
        id: 'find-replace',
        content: <TabFindReplace />,
      },
      {
        label: intl.formatMessage({
          id: 'Load.RecipientsList.TabEmptyField',
        }),
        id: 'empty',
        content: <TabEmptyField />,
      },
    ],
    [intl],
  )

  return (
    <StyledModal
      size={MODAL_SIZE_XL}
      show={show}
      onClose={handleCancel}
      data-mu-test="modal-bulk-find-replace"
      closeOnOverlayClick
      showClose
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.RecipientsList.ModalBulkFindReplaceEmptyTitle',
        })}
      />
      <Tabbed
        variant={TABBED_VARIANT_LIGHT}
        defaultActive="find-replace"
        data-mu-test="modal-bulk-find-replace__tabs"
        tabs={tabs}
      />
    </StyledModal>
  )
}

export default ModalBulkFindReplace
